<template>
  <div class="Index" >
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane label="安装" >
        <span slot="label"><i class="el-icon-s-home"></i>上门安装</span>
        <div class="title-tip">该服务目前仅支持门锁、晾衣机、智能窗帘，如有其它产品需求请前往自助留言反馈，谢谢！</div>
        <InstallInfo ref="InstallInfo">&nbsp;</InstallInfo>
      </el-tab-pane>
      <el-tab-pane label="维修">
        <span slot="label"><i class="el-icon-phone"></i>上门维修</span>
        <div class="title-tip">该服务目前仅支持门锁、晾衣机、智能窗帘，如有其它产品需求请前往自助留言反馈，谢谢！</div>
        <MaintainInfo ref="MaintainInfo">&nbsp;</MaintainInfo>
      </el-tab-pane>
      <el-tab-pane label="我的订单">
        <span slot="label"><i class="el-icon-user-solid"></i>进度查询</span>
        <MyOrder ref="MyOrder">&nbsp;</MyOrder>
      </el-tab-pane>
      <el-tab-pane label="在线留言">
        <span slot="label" @click="onlineMsg">自助留言</span>
      </el-tab-pane>
    </el-tabs>
<!--    <FloatBall :text="'在线留言'"></FloatBall>-->
<!--    <FloatButton></FloatButton>-->
  </div>
</template>

<script>
import levelProduct from '@/assets/levelproduct.json'
import InstallInfo from "../components/InstallInfo"
import MaintainInfo from "../components/MaintainInfo"
import MyOrder from "../components/MyOrder"
import wx from "weixin-js-sdk"
// import FloatBall from '@/components/FloatBall'
// import FloatButton from '@/components/FloatButton'

// import marqueeLeft from '@/components/marquee'
export default {
    name: "Index",
    components:{
    InstallInfo,
    MaintainInfo,
    MyOrder
    // ,FloatBall
    // ,FloatButton
    // ,marqueeLeft
    },
    data() {
        return{
            myProducts: [],   // 我的已有产品
            productNameArr: this.getServiceProductArr()    // 服务预约包括的产品范围
        }
    },
    created() {
        // 1. 该页面为微信回调页面，会携带参数code
        const code = this.$route.query.code
        // 2. 根据code和appid获取微信用户信息
        const appid = window.localStorage.getItem("fastappid")
        // this.$axios.get('/apis/Weixin/GetUserInfo?code=061HLe1C0knJvj2sgX0C0ftw1C0HLe1L&appId=wxa9f5dd8a96e17e12')
        // this.$axios.get('http://bullchat.vitters.cn/Weixin/GetUserInfo?code='+code+'&appId='+appid)
        this.$axios.get('http://bcss.gongniu.cn/wrc/Weixin/GetUserInfo?code='+code+'&appId='+appid)
        .then((response) => {
            // 3. 将openid和unionid存入localStorage
            window.localStorage.setItem("fastopenid",response.data.result.openid)
            window.localStorage.setItem("fastunionid",response.data.result.unionid)
            // 4. 根据unionid查找我的产品
            this.searchMyProductByUnionid(response.data.result.unionid)
        })
        .catch((error) => {
            // console.log(error);//异常
            this.$confirm('获取用户信息失败，请重试'+error, '', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'error',
                showClose: false,
                customClass: 'message-logout'
            }).then(() => {
                wx.closeWindow()
            }).catch(() => {
                // DO NOTHING
            });
        });
    },
    methods: {
        onlineMsg(){
            // console.log("在线留言")
            window.location.href = 'https://bull.custhelp.com/app/ask'
        },
        // 获取提供服务的产品范围
        getServiceProductArr(){
            let productArr = []
            levelProduct.forEach(function(item){
                item.series.forEach(function (args) {
                    args.product.forEach(function (param) {
                        productArr.push(param)
                    })
                })
            })
            // console.log("提供服务的产品型号：",productArr);
            return productArr
        },
        // 根据unionid查找我的产品
        searchMyProductByUnionid(unionid){
            this.$axios.get(this.$baseURL + `/rnow/unionidassets/` + unionid)
            .then(data=> {
                if(data.data==null || data.data=="" || data.data=='undefined'){
                    // 该unionid下无联系人资产
                    // console.log("IndexPage myProducts: 该unionid下无资产");
                }else {
                    // console.log(data.data);
                    for(let j = 0,len=data.data.length; j < len; j++) {
                        if(this.productNameArr.indexOf(data.data[j][3])<0){
                            // 查找到的已有产品，不在服务预约的产品范围内
                            continue;
                        }
                        let p = {
                            assetsId:data.data[j][0],
                            productId:data.data[j][1],
                            type:data.data[j][2],
                            series:this.confirmProductSeriesByModel(data.data[j][2],data.data[j][3]),
                            model:data.data[j][3],
                            snCode:data.data[j][4]}
                        this.myProducts.push(p)
                    }
                    // console.log("IndexPage myProducts: ",this.myProducts);
                }
                this.$refs.InstallInfo.setMyProducts(this.myProducts)
                this.$refs.MaintainInfo.setMyProducts(this.myProducts)
            })
            .catch(error=> {
                console.log(error)
            })
        },
        // 根据产品型号，确定产品系列
        confirmProductSeriesByModel(type,model){
            let series = ''
            try{
                levelProduct.forEach(function(item){
                    if (item.name === type){
                        item.series.forEach(function (args) {
                            args.product.forEach(function (param) {
                                if (param === model){
                                    series = args.name;
                                    // foreach没有break和return，抛出异常的方式跳出循环
                                    throw new Error("找到正确的系列")
                                }
                            })
                        })
                    }
                })
            }catch (e) {
                return series
            }
        }
    }
};
</script>

<style scoped>
  /*.Index {*/
  /*  height: 100%;*/
  /*}*/
  /*.Index > .el-tabs{*/
  /*  height: 100%;*/
  /*  position: relative;*/
  /*  overflow: hidden;*/
  /*}*/
  .title-tip {
    font-size: 12px;
    color: #c63e3e;
    margin: 0px 0px 10px 0px;
  }
</style>
<style>
  .el-tabs__item {
    padding : 0 10px!important;
  }
  /*.Index > .el-tabs > .el-tabs__content {*/
  /*  !*height: 100%;*!*/
  /*  !*display: table-cell;*!*/
  /*  overflow: scroll!important;*/
  /*  position: absolute!important;*/
  /*  top: 40px;*/
  /*  bottom: 0px;*/
  /*  left: 0px;*/
  /*  right: 0px;*/
  /*}*/
</style>
